// Needed polyfills will be determined by babel-env based on browserslist
// See https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md for an in-depth guide
// // See http://tobias-barth.net/blog/2019/07/Transpile-modern-language-features-with-Babel/ for a more hands-on library-focused guide

// core-js
import "core-js/es/array";
import "core-js/es/object";
import "core-js/es/string";
import "core-js/es/promise";
import "core-js/es/set";

import "whatwg-fetch";
import "requestidlecallback-polyfill";
import "./polyfills";
import "regenerator-runtime/runtime";

import "./Styles/vendor/vendor.scss";

//
// NOTE: Outcommented blocks could be stuff that we are using!
// If something stops working, please find correct package below and include it again in that components controller!
//

// import "@progress/kendo-ui/js/kendo.autocomplete";
// import "@progress/kendo-ui/js/kendo.binder";
// import "@progress/kendo-ui/js/kendo.button";
// import "@progress/kendo-ui/js/kendo.calendar";
// import "@progress/kendo-ui/js/kendo.color";
// import "@progress/kendo-ui/js/kendo.colorpicker";
// import "@progress/kendo-ui/js/kendo.columnmenu";
// import "@progress/kendo-ui/js/kendo.combobox";
// import "@progress/kendo-ui/js/kendo.core";
// import "@progress/kendo-ui/js/kendo.data";
// import "@progress/kendo-ui/js/kendo.datepicker";
// import "@progress/kendo-ui/js/kendo.datetimepicker";
// import "@progress/kendo-ui/js/kendo.dom";
// import "@progress/kendo-ui/js/kendo.draganddrop";
// import "@progress/kendo-ui/js/kendo.drawing";
// import "@progress/kendo-ui/js/kendo.dropdownlist";
// import "@progress/kendo-ui/js/kendo.editable";
// import "@progress/kendo-ui/js/kendo.excel";
// import "@progress/kendo-ui/js/kendo.filtercell";
// import "@progress/kendo-ui/js/kendo.filtermenu";
// import "@progress/kendo-ui/js/kendo.fx";
// import "@progress/kendo-ui/js/kendo.grid";
// import "@progress/kendo-ui/js/kendo.groupable";
// import "@progress/kendo-ui/js/kendo.list";
// import "@progress/kendo-ui/js/kendo.maskedtextbox";
// import "@progress/kendo-ui/js/kendo.menu";
// import "@progress/kendo-ui/js/kendo.multiselect";
// import "@progress/kendo-ui/js/kendo.numerictextbox";
// import "@progress/kendo-ui/js/kendo.ooxml";
// import "@progress/kendo-ui/js/kendo.pager";
// import "@progress/kendo-ui/js/kendo.pdf";
// import "@progress/kendo-ui/js/kendo.popup";
// import "@progress/kendo-ui/js/kendo.progressbar";
// import "@progress/kendo-ui/js/kendo.reorderable";
// import "@progress/kendo-ui/js/kendo.resizable";
// import "@progress/kendo-ui/js/kendo.responsivepanel";
// import "@progress/kendo-ui/js/kendo.selectable";
// import "@progress/kendo-ui/js/kendo.slider";
// import "@progress/kendo-ui/js/kendo.sortable";
// import "@progress/kendo-ui/js/kendo.spreadsheet";
// import "@progress/kendo-ui/js/kendo.switch";
// import "@progress/kendo-ui/js/kendo.timepicker";
// import "@progress/kendo-ui/js/kendo.toolbar";
// import "@progress/kendo-ui/js/kendo.userevents";
// import "@progress/kendo-ui/js/kendo.validator";
// import "@progress/kendo-ui/js/kendo.window";
// import "kendo-ui/js/kendo.tabstrip";
// import "kendo-ui/js/kendo.treeview";
